import React, { useEffect, useRef } from 'react';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import './audio-item.styles.scss';




const AudioItem = ({item, pauseAudio, index, emitPauseFunc}) => {
    const itemRef = useRef();
    const imgBoxRef = useRef();
    const imgRef = useRef();
    const infoRef = useRef();
    const audioInstance = useRef();

    useEffect(() => {
        itemRef.current.addEventListener('mouseover', () => {
            itemRef.current.style = 'height: 290px;';
            imgBoxRef.current.style = 'overflow: hidden;';
            imgRef.current.style = 'opacity: 1;';
            infoRef.current.style = 'opacity: 1;'
        })

    }, [])

    useEffect(() => {
        if (item.isPlaying === false) {
            audioInstance.current.audio.current.pause()
            // audioInstance.current;
        }
    }, [JSON.stringify(item)])

    const handleEmitPause = () => {
        item.isPlaying = true;
        emitPauseFunc(item);

    }

    const handlePause = (e) => {
        console.log(e)
    }
    
    return (

             <div className="audio-item" ref={itemRef} >
            <div className="imgBx" ref={imgBoxRef}>
                <img 
                    src={item.imgSrc} 
                    alt="album cover"
                    ref={imgRef}
                />
            </div>
            <div className="info" ref={infoRef}>
                {item.artist && <p>{item.artist.toUpperCase()} -</p>}
                <p>{item.title}</p>
                <div className="listen">
 
                    <AudioPlayer
                        src={item.url}
                        customAdditionalControls={[]}
                        showJumpControls={false} 
                        customVolumeControls={[]}
                        layout="horizontal-reverse"
                        ref={audioInstance}
                        onPlay={handleEmitPause}
                        onPause={handlePause}
                        
                    />
                </div>
            </div>    
        </div>
     
       
    )
}

export default AudioItem;